<template>
  <button :disabled="isStart">
    <span>{{ isStart ? timed + "S" : title }}</span>
  </button>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    time: {
      type: Number,
      default: 60
    }
  },
  data () {
    return {
      timed: this.time,
      isStart: false,
      timer: '',
    }
  },
  methods: {
    start () {
      this.isStart = true
      this.countDown()
    },
    pause () {
      this.isStart = false
      clearInterval(this.timer)
    },
    countDown () {
      this.timer = setInterval(() => {
        this.timed--
        if (this.timed === 0) {
          clearInterval(this.timer)
          this.isStart = false
          this.timed = this.time
        }
      }, 1000)
    }
  },
}
</script>